import { AuthStatus } from '../enum/auth-status.enum';

export class AuthStatusByCodeUtil {
  public static getAuthStatusByCode(code: string): AuthStatus {
    switch (code) {
      case "0":
      case "AUTHENTICATED":
        return AuthStatus.AUTHENTICATED;
      case "1":
      case "WAITING_OTP_VALIDATION":
        return AuthStatus.WAITING_OTP_VALIDATION;
      case "2":
      case "WAITING_OTP_CHECK":
        return AuthStatus.WAITING_OTP_CHECK;
      case "3":
      case "WAITING_PIN_VALIDATION":
        return AuthStatus.WAITING_PIN_VALIDATION;
      case "4":
      case "WAITING_CARD_VALIDATION":
        return AuthStatus.WAITING_CARD_VALIDATION;
      case "5":
      case "WAITING_REGISTRATION":
        return AuthStatus.WAITING_REGISTRATION;
      case "6":
      case "WAITING_CREATE_PIN":
        return AuthStatus.WAITING_CREATE_PIN;
      case "7":
      case "WAITING_REFRESH_PIN":
        return AuthStatus.WAITING_REFRESH_PIN;
    }
  }
}
